(function(){
  if(window.__nyWishlistEffectBound) return;
  window.__nyWishlistEffectBound = true;

  var SELECTOR = 'product-info [data-wishlist], product-info .wishlist-button';

  function ensureFillHeart(button){
    if(!button) return;
    if(button.querySelector('.ny-wishlist-fill-heart')) return;

    var fill = document.createElement('span');
    fill.className = 'ny-wishlist-fill-heart';
    fill.setAttribute('aria-hidden', 'true');
    fill.textContent = '♥';
    button.appendChild(fill);
  }

  function wishlistContains(button){
    try{
      var handle = button && button.getAttribute('data-wishlist-handle');
      var list = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
      return !!handle && Array.isArray(list) && list.indexOf(handle) > -1;
    }catch(e){
      return false;
    }
  }

  function isAdded(button){
    return !!button && (
      button.classList.contains('wishlist-added') ||
      button.classList.contains('ny-wishlist-added') ||
      wishlistContains(button)
    );
  }

  function syncVisual(button){
    if(!button) return;
    ensureFillHeart(button);

    if(button.classList.contains('wishlist-added') || wishlistContains(button)){
      button.classList.add('ny-wishlist-added');
    }else{
      button.classList.remove('ny-wishlist-added');
    }
  }

  function syncAll(){
    document.querySelectorAll(SELECTOR).forEach(syncVisual);
  }

  function getToast(){
    var toast = document.querySelector('.ny-wishlist-toast');
    if(toast) return toast;

    toast = document.createElement('div');
    toast.className = 'ny-wishlist-toast';
    toast.setAttribute('role','status');
    toast.setAttribute('aria-live','polite');
    toast.innerHTML = '<span class="ny-wishlist-toast__icon" aria-hidden="true">✓</span><span>Added to wishlist</span>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(){
    var toast = getToast();
    toast.classList.add('is-visible');

    clearTimeout(window.__nyWishToastTimer);
    window.__nyWishToastTimer = setTimeout(function(){
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function createBurst(x,y){
    var burst = document.createElement('div');
    burst.className = 'ny-wishlist-burst';
    burst.style.left = x + 'px';
    burst.style.top = y + 'px';

    for(var i = 0; i < 8; i++){
      burst.appendChild(document.createElement('span'));
    }

    document.body.appendChild(burst);
    setTimeout(function(){ burst.remove(); }, 720);
  }

  function animateAdd(button){
    ensureFillHeart(button);

    button.classList.remove('ny-wishlist-animate');
    button.classList.remove('ny-wishlist-ring');
    void button.offsetWidth;

    button.classList.add('ny-wishlist-added');
    button.classList.add('ny-wishlist-animate');
    button.classList.add('ny-wishlist-ring');

    setTimeout(function(){
      button.classList.remove('ny-wishlist-animate');
      button.classList.remove('ny-wishlist-ring');
      syncVisual(button);
    }, 560);
  }

  document.addEventListener('click', function(event){
    var button = event.target.closest(SELECTOR);
    if(!button) return;

    ensureFillHeart(button);

    var wasAdded = isAdded(button);

    if(wasAdded){
      button.classList.remove('ny-wishlist-added');
      button.classList.remove('ny-wishlist-animate');
      button.classList.remove('ny-wishlist-ring');

      setTimeout(function(){ syncVisual(button); }, 120);
      setTimeout(function(){ syncVisual(button); }, 450);
      return;
    }

    var rect = button.getBoundingClientRect();
    var x = rect.left + rect.width / 2;
    var y = rect.top + rect.height / 2;

    animateAdd(button);
    createBurst(x,y);
    showToast();

    setTimeout(function(){ syncVisual(button); }, 120);
    setTimeout(function(){ syncVisual(button); }, 450);
  }, true);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', syncAll);
  }else{
    syncAll();
  }

  document.addEventListener('shopify:section:load', syncAll);
})();
